"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWidth = void 0;
var react_1 = require("react");
var resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
var useMeasure = function (item) {
    var _a = react_1.useState(0), measure = _a[0], setMeasure = _a[1];
    var observer = react_1.useState(function () {
        return new resize_observer_polyfill_1.default(function (entries) {
            var entry = entries[0];
            if (entry.contentRect[item] !== measure) {
                setMeasure(entry.contentRect[item]);
            }
        });
    })[0];
    var ref = react_1.useCallback(function (node) {
        observer.disconnect();
        if (node) {
            observer.observe(node);
        }
    }, [observer]);
    return [ref, measure];
};
exports.useWidth = function () { return useMeasure('width'); };
//# sourceMappingURL=useMeasure.js.map